import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./contact.css";

const Contact = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    // console.log("Service ID:", process.env.REACT_APP_EMAILJS_SERVICE_ID);
    // console.log("Template ID:", process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
    // console.log("Public Key:", process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
  .sendForm(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    form.current,
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY
  )
  .then(
    (result) => {
      console.log(result.text);
      toast.success("Message sent successfully!");
      setFormData({
        user_name: "",
        user_email: "",
        subject: "",
        message: "",
      });
    },
    (error) => {
      console.log("FAILED", error.text);
      toast.error("Failed to send message. Please try again later.");
    }
  );

  };

  return (
    <section className="contact container section" id="contact">
      <ToastContainer />
      <h2 className="section__title">Get In Touch</h2>
      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's Talk About Everything!</h3>
          <p className="contact__details">
            Don't Like Forms? Send Me An Email 👋
          </p>
        </div>
        <form ref={form} onSubmit={sendEmail} className="contact__form">
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                name="user_name"
                className="contact__form-input"
                placeholder="Enter Your Name"
                value={formData.user_name}
                onChange={handleChange}
              />
            </div>
            <div className="contact__form-div">
              <input
                type="email"
                name="user_email"
                className="contact__form-input"
                placeholder="Enter Your Email"
                value={formData.user_email}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="contact__form-div">
            <input
              type="text"
              name="subject"
              className="contact__form-input"
              placeholder="Enter Your Subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>
          <div className="contact__form-div contact__form-area">
            <textarea
              name="message"
              cols={30}
              rows={10}
              className="contact__form-input"
              placeholder="Write Your Message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>
          <button type="submit" className="btn">Send Message</button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
